import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
  color?: string;
}

const ArrowDownIcon: React.FC<IconProps> = ({
  color = '#A5A4AA',
  ...props
}) => (
  <svg
    width="12"
    height="7"
    color="#A5A4AA"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.99677 4.76692L10.1256 0.542119C10.2661 0.398418 10.4323 0.328867 10.6244 0.333466C10.8166 0.338064 10.9827 0.412405 11.1227 0.556489C11.2628 0.700573 11.333 0.870714 11.3334 1.06691C11.3337 1.26311 11.2635 1.43306 11.1227 1.57676L6.79726 5.98837C6.68491 6.10333 6.55852 6.18955 6.41808 6.24703C6.27765 6.30451 6.13721 6.33325 5.99677 6.33325C5.85634 6.33325 5.7159 6.30451 5.57546 6.24703C5.43503 6.18955 5.30863 6.10333 5.19628 5.98837L0.87083 1.56239C0.730393 1.41869 0.662421 1.25104 0.666916 1.05944C0.67141 0.86784 0.744062 0.700189 0.884873 0.556489C1.02569 0.412788 1.19196 0.340938 1.38371 0.340938C1.57545 0.340938 1.74154 0.412788 1.88198 0.556489L5.99677 4.76692Z"
      fill={color}
    />
  </svg>
);

export default ArrowDownIcon;
